import { getLocale } from '../i18n/locale'
import { Images, QuestionGroup, QuestionType, ScenarioStep, Steps } from '../state/interfaces'
import { emailAddress } from './common-steps'

export const decisionMobileInternetReview: ScenarioStep = {
  id: Steps.DECISION_MOBILE_INTERNET_REVIEW,
  group: QuestionGroup.DECISION,
  question: 'decision-mobile-internet-review_question',
  tip: 'decision-mobile-internet-review_tip',
  type: QuestionType.MIXED_CHOICE_WITH_PILLS_LARGE_DECISION,
  next: Steps.DONE,
  answers: [
    {
      id: 'mobile',
      text: 'mobile-carrier_option',
      metadata: { image: Images.CELL_PHONE_STATE_1, imageSelected: Images.CELL_PHONE_STATE_2 },
    },
    {
      id: 'internet',
      text: 'internet-service-provider_option',
      metadata: { image: Images.INTERNET_STATE_1, imageSelected: Images.INTERNET_STATE_2 },
    },
  ],
}

export const emailAddressReviewContest: ScenarioStep = {
  ...emailAddress,
  question: 'email-address-review-contest_question',
  tip: 'email-address-review-contest_tip',
  answerPlaceholder: 'email-address_answerPlaceholder',
  next: Steps.DECISION_MOBILE_INTERNET_REVIEW,
  metadata: { grandImage: getLocale() === 'en' ? Images.REVIEW_CONTEST_EN : Images.REVIEW_CONTEST_FR },
}
